module.exports = __webpack_public_path__ + "img/motorbikeTopOutline.64f8307e.svg";